export const TypeUser = [
  'Interne',
  'Externe',
] as const

export type TypeUser = typeof TypeUser[number]

export const TypeUserLibelle: {
  [key in TypeUser]: string
} = {
  Interne: 'Interne',
  Externe: 'Externe',
} as const
